export const adjustedFormCartoonStock = [
  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select vendor",
    isRequired: false,
    valueLabel: "vendor", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
  {
    type: "select",
    labelName: "Bill Number",
    placeholder: "Select bill Number",
    isRequired: false,
    valueLabel: "bill_number", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
];

export const adjustedFormPlasticStock = [
  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select vendor",
    isRequired: false,
    valueLabel: "vendor", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
  {
    type: "select",
    labelName: "Bill Number",
    placeholder: "Select bill Number",
    isRequired: false,
    valueLabel: "bill_number", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
];

export const adjustedFormLeafStock = [
  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select vendor",
    isRequired: false,
    valueLabel: "vendor", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
  {
    type: "select",
    labelName: "Bill Number",
    placeholder: "Select bill Number",
    isRequired: false,
    valueLabel: "bill_number", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
];
export const adjustedFormCartoonWithDraw = [];
export const adjustedFormPlasticWithDraw = [];
export const adjustedFormStickerStock = [];
